import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setError, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PENDENCIA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('pendenciaForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'PENDENCIA_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PENDENCIA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(documentos) {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'PENDENCIA_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

		const filtro = getState().pendencia.filtro;
		const status = filtro.id_status == 'ambas' ? null : filtro.id_status;

    	axios.get(`${consts.API_URL}/pendencia?id_setor=${filtro.id_setor}&id_tipo=${filtro.id_tipo}&id_status=${status}`).then(resp => {
			dispatch({
		        type: 'PENDENCIA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaLog(idPendencia) {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'PENDENCIA_LOG_LISTADO',
			payload: { data: [] }
		});

    	axios.get(`${consts.API_URL}/pendencia/listarLog?id_pendencia=${idPendencia}`).then(resp => {
			dispatch({
		        type: 'PENDENCIA_LOG_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
	return async (dispatch, getState) => {
		if (!registro.id) {
			
			let lista = [];

			if ((registro.ids_motoristas || []).length) {
				lista = (registro.ids_motoristas || []).map(item => ({
					...registro,
					id_motorista: item
				}));
			} else if ((registro.cavalos || []).length) {
				lista = (registro.cavalos || []).map(item => ({
					...registro,
					cavalo: item
				}));
			} else if ((registro.carretas || []).length) {
				lista = (registro.carretas || []).map(item => ({
					...registro,
					carreta: item
				}));
			} else {
				lista.push(registro);
			}

			try {

				for (const item of lista) {
					await axios.post(`${consts.API_URL}/pendencia`, {
						...item,
						id_usuario_inclusao: getState().auth.usuario.id,
						id_usuario_alteracao: getState().auth.usuario.id
					});
				}

				setSuccess('Operação realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));

			} catch (e) {
				setErroAPI(e);
			}
			
		} else {
			axios.put(`${consts.API_URL}/pendencia`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
	};
}

export function setResolvida(registro) {
	return async (dispatch, getState) => {
		await axios.put(`${consts.API_URL}/pendencia`, {
			...registro,
            resolvida: !registro.resolvida,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pendencia?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaMotorista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/motorista/listarSelect?contrato_ativo=true`)
		.then(resp => {			
			dispatch({
				type: 'PENDENCIA_MOTORISTA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaPlaca() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/controlePatio/listarPlacas`)
		.then(resp => {			
			dispatch({
				type: 'PENDENCIA_PLACA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}